import M from "dayjs";
var f = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function y(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Y = { exports: {} };
(function(n, w) {
  (function(d, o) {
    n.exports = o(M);
  })(f, function(d) {
    function o(t) {
      return t && typeof t == "object" && "default" in t ? t : { default: t };
    }
    var c = o(d);
    function u(t) {
      return t % 10 < 5 && t % 10 > 1 && ~~(t / 10) % 10 != 1;
    }
    function r(t, s, i) {
      var a = t + " ";
      switch (i) {
        case "m":
          return s ? "minuta" : "minutę";
        case "mm":
          return a + (u(t) ? "minuty" : "minut");
        case "h":
          return s ? "godzina" : "godzinę";
        case "hh":
          return a + (u(t) ? "godziny" : "godzin");
        case "MM":
          return a + (u(t) ? "miesiące" : "miesięcy");
        case "yy":
          return a + (u(t) ? "lata" : "lat");
      }
    }
    var p = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"), e = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"), m = /D MMMM/, l = function(t, s) {
      return m.test(s) ? p[t.month()] : e[t.month()];
    };
    l.s = e, l.f = p;
    var _ = { name: "pl", weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"), weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"), weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"), months: l, monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"), ordinal: function(t) {
      return t + ".";
    }, weekStart: 1, yearStart: 4, relativeTime: { future: "za %s", past: "%s temu", s: "kilka sekund", m: r, mm: r, h: r, hh: r, d: "1 dzień", dd: "%d dni", M: "miesiąc", MM: r, y: "rok", yy: r }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" } };
    return c.default.locale(_, null, !0), _;
  });
})(Y);
var k = Y.exports;
const H = /* @__PURE__ */ y(k);
var h = { exports: {} };
(function(n, w) {
  (function(d, o) {
    n.exports = o(M);
  })(f, function(d) {
    function o(_) {
      return _ && typeof _ == "object" && "default" in _ ? _ : { default: _ };
    }
    var c = o(d), u = "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"), r = "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_"), p = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function e(_, t, s) {
      var i, a;
      return s === "m" ? t ? "хвилина" : "хвилину" : s === "h" ? t ? "година" : "годину" : _ + " " + (i = +_, a = { ss: t ? "секунда_секунди_секунд" : "секунду_секунди_секунд", mm: t ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин", hh: t ? "година_години_годин" : "годину_години_годин", dd: "день_дні_днів", MM: "місяць_місяці_місяців", yy: "рік_роки_років" }[s].split("_"), i % 10 == 1 && i % 100 != 11 ? a[0] : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? a[1] : a[2]);
    }
    var m = function(_, t) {
      return p.test(t) ? u[_.month()] : r[_.month()];
    };
    m.s = r, m.f = u;
    var l = { name: "uk", weekdays: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"), weekdaysShort: "ндл_пнд_втр_срд_чтв_птн_сбт".split("_"), weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"), months: m, monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"), weekStart: 1, relativeTime: { future: "за %s", past: "%s тому", s: "декілька секунд", m: e, mm: e, h: e, hh: e, d: "день", dd: e, M: "місяць", MM: e, y: "рік", yy: e }, ordinal: function(_) {
      return _;
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY р.", LLL: "D MMMM YYYY р., HH:mm", LLLL: "dddd, D MMMM YYYY р., HH:mm" } };
    return c.default.locale(l, null, !0), l;
  });
})(h);
var z = h.exports;
const v = /* @__PURE__ */ y(z);
export {
  f as c,
  y as g,
  H as p,
  v as u
};
//# sourceMappingURL=uk-DtS-21WL.js.map
